import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'

import CampusPerfectCard from 'components/organisms/CampusPerfectCard'
import SchoolFoundTitle from 'components/search/SchoolFoundTitle'
import { Container, Row, Col } from 'components/qstrap'

const propTypes = {
  schools: PropTypes.arrayOf(PropTypes.object).isRequired,
  onShowMore: PropTypes.func,
  totalSchools: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  lastPage: PropTypes.bool,
}

const defaultProps = {
  totalSchools: 0,
  lastPage: false,
  onShowMore: () => {},
}

const SchoolCardList = (props) => {
  const showMoreTag = (() => {
    if (props.lastPage) {
      return ''
    }
    return (
      <div className="see-more-schools text-center" onClick={props.onShowMore}>
        {intl.get('search.see_more_schools')}
      </div>
    )
  })()

  return (
    <Container id="school-card-list">
      <div id="school-card-list-container">
        <SchoolFoundTitle totalSchools={props.totalSchools} />

        <div>
          <Row className="fix">
            {
              props.schools.map((school, idx) => (
                <Col md="4" sm="6" className="m-y-sm col-xs-12" key={school.id}>
                  <CampusPerfectCard
                    dataTestId={`dir-campus-card-${idx}`}
                    category={intl.get(`search.sector.${school.sector}`)}
                    description={school.description}
                    href={`/directory/${school.slug}`}
                    kind="schools"
                    likeable
                    likeStatus={school.liked}
                    likeTarget={school.id}
                    logo={school.logo}
                    title={school.name}
                    thumbnail={school.image}
                    withFooter
                  />
                </Col>
              ))
            }
          </Row>
        </div>

        {showMoreTag}
      </div>
    </Container>
  )
}

SchoolCardList.propTypes = propTypes
SchoolCardList.defaultProps = defaultProps

export default SchoolCardList
